/**
 * Animate header
 */
const tlHeader = gsap.timeline({
  scrollTrigger: {
    trigger: ".page-header",
    start: "top top",
    end: "bottom top",
    scrub: 2
  }
});

gsap.utils.toArray(".parallax").forEach(layer => {
  const depth = layer.dataset.depth;
  const movement = -(300 * depth)
  tlHeader.to(layer, {y: movement, ease: "none"}, 0)
});


/**
 * Animate comparison slider
 *
 * https://img-comparison-slider.sneas.io/
 */
gsap.utils.toArray(".slider").forEach(slider => {
  gsap.to(slider, {
    value: 50,
    duration: 1,
    scrollTrigger: {
      // markers: true,
      trigger: slider,
      start: "top center"
    }
  })
})




/**
 * Splide carousel
 *
 * https://splidejs.com/
 */
const splide = new Splide('.splide', {
  perMove: 1,
  gap: "4rem",
  fixedWidth: "60vw",
  pagination: false,
  focus      : 'center',
  trimSpace  : false
});

const splideProgressTextLenght = splide.root.querySelector('.slider-progress-text-lenght');
const splideProgressTextIndex = splide.root.querySelector('.slider-progress-text-index');
const splideProgressBarStatus = splide.root.querySelector( '.slider-progress-bar-status' );
// Updates the bar width whenever the carousel moves:
splide.on('mounted move', function () {
  let end  = splide.Components.Controller.getEnd() + 1;
  let rate = Math.min( ( splide.index + 1 ) / end, 1 );
  splideProgressBarStatus.style.width = String( 100 * rate ) + '%';
  splideProgressTextLenght.textContent = String(splide.length).padStart(2, "0");
  splideProgressTextIndex.textContent = String(splide.index + 1).padStart(2, "0");
});

splide.mount();


/**
 * Extract the device orientation from window.matchMedia
 *
 * We set the splide width based on the device orientation.
 *
 * @param e
 * @returns {string}
 */
const getOrientation = function (e) {
  if(e.matches) {
    // Portrait mode
    splide.options = {
      fixedWidth: "80vw",
    }
  } else {
    // Landscape
    splide.options = {
      fixedWidth: "60vw",
    }
  }
};

/**
 * Get device orientation and update on change.
 * @type {MediaQueryList}
 */
let portrait = window.matchMedia("(orientation: portrait)");
getOrientation(portrait);
portrait.addEventListener("change", getOrientation)
